
import React, { Component } from "react";

import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsySelectFormGroup extends Component {

    constructor(props) {
        super(props)
        let groupExpandedMap = {};
        groupExpandedMap[props.appid] = true;
        this.state = {
            ...props,
            selectGroup: null,
            groupExpandedMap: groupExpandedMap,
        }
    }

    selectApp = (id) => {
        return (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.props.getSelectFormGroupId && this.props.getSelectFormGroupId(id);
            this.setState({ selectGroup: id })
        }

    }

    toTarget = (val) => {
        let { groupExpandedMap } = this.state;
        return (event) => {
            event.preventDefault();
            event.stopPropagation();
            groupExpandedMap[val.entryId] = !groupExpandedMap[val.entryId]
            this.setState({ groupExpandedMap })
        }
    }


    toAppTarget = () => {
        const { appid } = this.state;
        let { groupExpandedMap } = this.state;
        return (event) => {
            event.preventDefault();
            event.stopPropagation();
            groupExpandedMap[appid] = !groupExpandedMap[appid]
            this.setState({ groupExpandedMap })
        }
    }


    createFormDashMenuTree = (val, childLevel) => {
        const { entryMap, editable, deletable, copyable, dock, entryid, appid, selectGroup, current } = this.state;
        const editAuth = BsyUtils.hasTokenEdit(appid) || ((window.FX.STATIC["user_corps"].isSysManager || editable || deletable || copyable) && !dock);
        if (current._id === entryMap[val.id]._id || (current.type === "group" && childLevel > 1)) {
            return;
        }

        let { groupExpandedMap } = this.state;
        if (entryMap[val.id]) {
            if (entryMap[val.id].type === "group") {

                if (entryMap[val.id]) {
                    if (!groupExpandedMap.hasOwnProperty(val.id)) {
                        groupExpandedMap[val.id] = false;
                    }
                }

                //提前计算 当前分组中有没有选中的表单
                if (val.child) {
                    val.child.map((child) => {
                        if (child.id === entryid) {
                            groupExpandedMap[val.id] = true;
                        }
                    })
                }

                let dot = [];
                for (let i = 0; i < childLevel; i++) {
                    dot.push(<span className="itemDot"></span>)
                }
                childLevel = childLevel + 1;
                let hasChild = false;
                if (childLevel < 3) {
                    val.child && val.child.map((val1) => {
                        if (entryMap[val1.id].type == "group") {
                            hasChild = true
                        }
                    })
                }
                return entryMap[val.id] &&
                    <li data-id={val.id} className={"group-pane"}
                        key={val.id + appid + new Date().getTime()}>
                        {

                            <div className={"menu-item group-pane-menu-item" + (selectGroup === val.id ? " selected" : "")} id={"menu" + val.id}
                                title={entryMap[val.id].name}
                                onClick={this.selectApp(val.id)}>
                                <div className="item">
                                    {
                                        dot.map(res => {
                                            return res
                                        })
                                    }

                                    <span className="group-switch-icon">
                                        <i style={{ visibility: (current.type === "group" || !hasChild) ? 'hidden' : '' }} className={`node-icon ` + (groupExpandedMap[val.id] ? "icon-tree-collapse" : "icon-tree-expand")} onClick={this.toTarget(entryMap[val.id], editAuth)}></i>
                                    </span>
                                    <i className={"icon-bsy-folder-close"} />
                                    <span>{entryMap[val.id].name}</span>
                                </div>
                            </div>
                        }
                        {
                            <ul style={{ display: groupExpandedMap[val.id] ? "block" : 'none' }}>
                                {

                                    val.child && val.child.map((val1) => {
                                        if (val1.id === entryid) {
                                            groupExpandedMap[val.id] = true;
                                        }
                                        return this.createFormDashMenuTree(val1, childLevel)
                                    })
                                }
                            </ul>
                        }
                    </li>
            }
        }
    }

    render() {
        const { currentApp, treeNodes, appid } = this.props;
        const { groupExpandedMap, selectGroup } = this.state;
        let childLevel = 1;
        return (
            <div className='BsySelectFormGroup'>
                <div className="selectgroupTitle">{React.language('app.edit.folder.select')}</div>
                <div className="appGroupMenu">
                    <div className={"appItem" + (selectGroup === appid ? " selected" : "")} onClick={this.selectApp(appid)}>
                        <div className="switch-icon">
                            <i className={`node-icon ` + (groupExpandedMap[appid] ? "icon-tree-collapse" : "icon-tree-expand")} onClick={this.toAppTarget(currentApp)}></i>
                        </div>
                        <div className={"app-icon color-cover-" + currentApp.style.color}>
                            <div className={"imgbg-small-bsy-app imgbg-bsy-app-" + currentApp.style.icon}></div>
                        </div>
                        <span>{currentApp.appname}</span>
                    </div>
                    <ul className="formGroupList" style={{ display: groupExpandedMap[appid] ? "block" : 'none' }}>
                        {
                            treeNodes.length == 0 ? '' : treeNodes.map((val) => {
                                return this.createFormDashMenuTree(val, childLevel)
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    }
}